import {Component, input, output} from '@angular/core';
import {UploadDocumentCardComponent} from '../../../../../customer/project-sequence/chapter/chapter-8-rfq/step-8-4-provider-results/document/upload-document-card/upload-document-card.component';
import {
  InvitationUploadDocumentResponse,
  CreateInvitationDocumentRequestParams,
  InvitationUploadDocumentEditRequest,
} from '@frontend/shared-api';
import {InvitationUploadDocument} from '@frontend/directus';

@Component({
  selector: 'app-provider-document-upload',
  imports: [UploadDocumentCardComponent],
  templateUrl: './provider-document-upload.component.html',
})
export class ProviderDocumentUploadComponent {
  readonly uploadDocumentsCategory = input.required<InvitationUploadDocument[]>();
  readonly documents = input.required<InvitationUploadDocumentResponse[]>();
  readonly isEditable = input<boolean>(false);

  readonly uploadDocument = output<CreateInvitationDocumentRequestParams>();
  readonly previewDocument = output<number>();
  readonly editDocument = output<InvitationUploadDocumentEditRequest>();
  readonly downloadDocument = output<number>();
  readonly deleteDocument = output<number>();

  protected getFilteredDocs(uuid: string) {
    return this.documents().filter((d) => d.invitationUploadDocumentUuid === uuid);
  }
}
